import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { COLORS } from 'config/theme/baseTheme';

const useStyles = makeStyles(() =>
  createStyles({
    asterisk: {
      color: COLORS.ALIZARIN_CRIMSON, 
      marginLeft: '2px'
    }
  })
);

const MandatoryAsterisk: React.FC = () => {
  const classes = useStyles();
  // Asterisk is hidden from screen readers; ensure the associated input has required/aria-required
  return <span className={classes.asterisk} aria-hidden="true">*</span>;
};

export default MandatoryAsterisk;
